import { useQuery } from 'react-query'
import { auth_config } from '../../../../features/API/auth_config'
import axios from 'axios'

export const useJWTValidation = (jwt) => {
  return useQuery(
    'jwt-validation',
    () =>
      axios.get(auth_config.validatePath, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      }),
    {
      retry: false,
      refetchInterval: 30 * 1000, // validate the token every 30 seconds
    }
  )
}
